export const HeaderUploadMasterImage = [
  'Object/Item Name',
  'Reference Object',
  'Images File Name',
  'Action',
];
